// 📄 pages/Ariba/components/KnownErrorCard.tsx
import React from 'react';
import { Paperclip, ChevronRight, AlertTriangle } from 'lucide-react';
import { KnownError, sistemaAfectadoMeta } from '../../../services/knownErrorsService.ts';

interface KnownErrorCardProps {
  error: KnownError;
  onClick: () => void;
}

export default function KnownErrorCard({ error, onClick }: KnownErrorCardProps) {
  const sistema = sistemaAfectadoMeta(error.sistemaAfectado);

  return (
    <div
      onClick={onClick}
      className="group flex items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-4 cursor-pointer transition-all duration-150 hover:border-blue-400 hover:-translate-y-0.5 hover:shadow-lg"
    >
      <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-[rgba(91,155,240,0.12)]">
        <AlertTriangle className="w-5 h-5 text-blue-400" />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-mono font-semibold text-blue-400">{error.code}</span>
          <span className="text-sm font-medium text-white truncate">{error.title}</span>
          {sistema && (
            <span className="text-[10px] bg-sky-500/10 text-sky-300 border border-sky-500/30 px-2 py-0.5 rounded-full flex-shrink-0">{sistema.label}</span>
          )}
        </div>
        <p className="text-xs text-gray-400 mt-1 line-clamp-2">{error.summary}</p>
      </div>

      {error.attachments.length > 0 && (
        <div className="flex items-center gap-1 text-gray-500 flex-shrink-0" title={`${error.attachments.length} adjunto(s)`}>
          <Paperclip className="w-4 h-4" />
        </div>
      )}

      <ChevronRight className="w-4 h-4 text-gray-600 group-hover:text-blue-400 transition-colors flex-shrink-0" />
    </div>
  );
}
